import {
    GET_LIST_COMMISSION,
    COMMISSION_STATISTICAL
} from '../actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    commissions: [],
    statistical: null,
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_COMMISSION: {
            return {
                ...state,
                commissions: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            }
        }
        case COMMISSION_STATISTICAL:
            return {
                ...state,
                statistical: action.payload
            };
        default: return { ...state };
    }
}
